"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Moment_1 = __importDefault(require("../../../Moment"));

var API_TO_MOMENT_MAP = Object.freeze({
  award: Moment_1.default.AwardMoment,
  audio: Moment_1.default.AudioMoment,
  education: Moment_1.default.EducationMoment,
  employer: Moment_1.default.EmployerMoment,
  iframe: Moment_1.default.IFrameMoment,
  image: Moment_1.default.ImageMoment,
  library: Moment_1.default.LibraryMoment,
  map: Moment_1.default.MapMoment,
  membership: Moment_1.default.MembershipMoment,
  mirador: Moment_1.default.MiradorMoment,
  named_after: Moment_1.default.NamedAfterMoment,
  pdf: Moment_1.default.PDFMoment,
  people: Moment_1.default.PeopleMoment,
  reference: Moment_1.default.ReferenceMoment,
  software_heritage: Moment_1.default.SoftwareHeritageMoment,
  stat: Moment_1.default.StatMoment,
  timeline: Moment_1.default.TimelineMoment,
  video: Moment_1.default.VideoMoment,
  wikidata: Moment_1.default.WikidataMoment,
  wikipedia: Moment_1.default.WikipediaMoment,
  youtube: Moment_1.default.YouTubeMoment
});
exports.default = API_TO_MOMENT_MAP;